import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

interface DeleteWorkfrontConfigInput {
  clientId: string;
  configId: string;
}

/** Mutation for `DELETE /v1/clients/{clientId}/workfront-configs/{configId}` (Admin only). */
export function useDeleteWorkfrontConfigMutation(): UseMutationResult<
  void,
  Error,
  DeleteWorkfrontConfigInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, configId }: DeleteWorkfrontConfigInput) => {
      if (!api) throw new Error('useDeleteWorkfrontConfigMutation: api client unavailable');
      return api.delete<void>(`/v1/clients/${clientId}/workfront-configs/${configId}`);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['workfront-configs', clientId] });
    },
  });
}
